<template>
  <div class="table-crud-modal" ref="editModal">
    <h2 class="lvl2-heading">Modifier l'utilisateur</h2>
    <el-form
      ref="editUserForm"
      :rules="rules"
      :model="params"
      label-position="left"
      :status-icon="true"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="email">
            <span>Email:*</span>
            <el-input v-model="params.email" placeholder="Email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="role">
            <span>Rôle*:</span>
            <el-select
              no-data-text="..."
              v-model="params.role"
              placeholder="Rôle"
            >
              <el-option
                v-for="role in roles"
                :key="`role__f-${role.value}`"
                :label="role.label"
                :value="role.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="last_name">
            <span>Nom*:</span>
            <el-input v-model="params.last_name" placeholder="Nom"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="first_name">
            <span>Prénom*:</span>
            <el-input
              v-model="params.first_name"
              placeholder="Prénom"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item prop="company">
            <span>Société:</span>
            <el-input v-model="params.company" placeholder="Société"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="group">
            <span>Groupement:</span>
            <el-input v-model="params.group" placeholder="Groupement" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="supports__form--actions" v-if="isPharmacist">
        <h3>Supports</h3>
        <button class="supports__form--button" @click.prevent="addNewLine">
          +
        </button>
      </div>
      <el-row :gutter="20" v-if="isPharmacist">
        <!-- <el-col :span="12">
          <el-form-item prop="support">
            <span>Supports:</span>
            <multiselect
              class="form__multiselect"
              v-model="params.userSupports"
              :options="params.userSupports"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :taggable="true"
              @tag="addSupport"
              @remove="removeSupport"
              :preserve-search="false"
              tag-placeholder="[ENTRER] pour ajouter"
              deselect-label="[ENTRER] pour supprimer"
              label="name"
              track-by="name"
              selectedLabel="Selectionné"
              :preselect-first="false"
            >
              <template v-slot:noOptions>
                Cet utilisateur ne dispose d'aucun support
              </template>
            </multiselect>
          </el-form-item>
        </el-col> -->

        <el-col :span="24">
          <div class="supports__form--container">
            <div
              :key="`format--${index}`"
              v-for="(supp, index) in params.userSupports"
              class="no-margin"
            >
              <div class="supports__form-item">
                <el-form-item
                  class="no-margin"
                  style="width: 100%"
                  :prop="'userSupports.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: 'Le nom est obligatoire',
                    trigger: 'blur'
                  }"
                >
                  <el-input
                    placeholder="Nom du support"
                    v-model="supp.name"
                    class="no-min-width"
                    :disabled="Number(supp.type_support.is_global) === 1"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  class="no-margin"
                  style="width: 100%"
                  :prop="'userSupports.' + index + '.type_support_id'"
                  :rules="{
                    required: true,
                    message: 'Le type de support est obligatoire',
                    trigger: 'blur'
                  }"
                >
                  <el-select
                    no-data-text="..."
                    popper-class="supports-f"
                    v-model="supp.type_support_id"
                    placeholder="Type de support"
                    filterable
                    default-first-option
                    :disabled="Number(supp.type_support.is_global) === 1"
                  >
                    <el-option
                      v-for="sup in supportstypes.data.options"
                      :key="`sup__f-${sup.name}`"
                      :label="sup.name"
                      :value="sup.id"
                      :disabled="Number(sup.is_global) === 1"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="no-margin"
                  style="width: 100%"
                  :prop="'userSupports.' + index + '.format'"
                  :rules="{
                    required: true,
                    message: 'Le format est obligatoire',
                    trigger: 'blur'
                  }"
                >
                  <el-input
                    placeholder="Format"
                    v-model="supp.format"
                    class="no-min-width"
                    :disabled="Number(supp.type_support.is_global) === 1"
                  ></el-input>
                </el-form-item>
                <button
                  v-if="!supp.type_support.is_global"
                  class="supports__form--button"
                  @click.prevent="removeLine(index)"
                >
                  -
                </button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item prop="plannings_start_day">
            <span>Démarrage des plannings mensuels:</span>
            <el-input-number
              v-model="params.plannings_start_day"
              :min="1"
              :max="28"
              :controls="false"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item prop="ean">
            <span>EAN:</span>
            <el-input v-model="params.ean" placeholder="EAN"></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item prop="activity_started_at">
            <span>Date de début d'activité:</span>
            <el-date-picker
              v-model="params.activity_started_at"
              placeholder="Date de début d'activité"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item prop="categorie_id">
            <span>Classification:</span>
            <el-select
              class="pf-table-view__filter-item"
              v-model="params.categorie_id"
              placeholder="Classification"
              no-data-text="..."
            >
              <el-option
                v-for="category in categories"
                :key="`category__${category.id}`"
                :label="category.name"
                :value="category.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--
          <el-form-item prop="labo">
            <span>Labos:</span>
            <el-select
              no-data-text="..."
              popper-class="labos-f"
              v-model="params.labosIds"
              placeholder="Labos"
              filterable
              multiple
            >
              <el-option
                v-for="lab in labos"
                :key="`lab__f-${lab.id}`"
                :label="lab.name"
                :value="lab.id"
                selected
              ></el-option>
            </el-select>
          </el-form-item>
          -->
        </el-col>
        <el-col :span="12">
          <el-form-item prop="chiffre_affaires">
            <span>Chiffre d'affaires:</span>
            <el-input
              v-model="params.chiffre_affaires"
              placeholder="Chiffre d'affaires"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item prop="media">
            <span>IBAN:</span>
            <FileUpload
              name="media-upload"
              placeholder="IBAN"
              v-if="!params.rib"
              :acceptedTypes="[
                'application/pdf',
                'image/png',
                'image/jpeg',
                'image/jpg'
              ]"
              @file-upload="params.rib = $event"
            />
            <template v-else>
              <base-link
                path
                class="iban-image__name"
                @click.native.prevent="downloadUserRib"
                >RIB</base-link
              >
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item prop="thumbnail">
            <div class="supports__form--actions">
              <span style="flex: 1">Plan Pharmacie:</span>
              <button
                class="supports__form--button supports__plan--view"
                @click.prevent="openBlueprintModal()"
                v-if="existingPlans.length > 0"
              >
                <img
                  width="25"
                  :src="require(`@/assets/eye.png`)"
                  alt="assets"
                />
              </button>
              <button
                class="supports__form--button"
                @click.prevent="addPlanLine"
              >
                +
              </button>
            </div>
            <div class="supports__form--plans">
              <div
                class="supports__form--plan"
                v-for="(plan, key) in existingPlans"
                :key="`plans__existing--${plan.id}`"
              >
                <!-- <ImageThumbnail
                  @click.native="openBlueprintModal"
                  v-if="
                    params.pharmacy_plans &&
                      typeof params.pharmacy_plans === 'string'
                  "
                  :imageUrl="params.pharmacy_plans"
                /> -->
                <FileUpload
                  name="thumbnail-upload"
                  :key="`plans__upload--${plan.id}`"
                  :placeholder="
                    typeof plan.file == 'string' ? plan.name : 'Plan Pharmacie'
                  "
                  :acceptedTypes="[
                    'application/pdf',
                    'image/png',
                    'image/gif',
                    'image/bmp',
                    'image/jpeg',
                    'image/jpg',
                    'image/svg+xml',
                    'image/x-icon',
                    'image/pipeg',
                    'video/mp4',
                    'video/mpeg',
                    'video/quicktime',
                    'video/x-la-asf',
                    'video/x-ms-asf',
                    'video/x-msvideo',
                    'video/x-sgi-movie'
                  ]"
                  :upload="!plan.file"
                  :editable="false"
                  @file-upload="fileUpload($event, `plans__${plan.id}`)"
                />
                <button
                  class="supports__form--button"
                  @click.prevent="removeExistingPlanLine(key, $event)"
                >
                  -
                </button>
              </div>
              <div
                class="supports__form--plan"
                v-for="(plan, key) in params.pharmacy_plans"
                :key="`plans__${plan.id}`"
              >
                <!-- <ImageThumbnail
                  @click.native="openBlueprintModal"
                  v-if="
                    params.pharmacy_plans &&
                      typeof params.pharmacy_plans === 'string'
                  "
                  :imageUrl="params.pharmacy_plans"
                /> -->
                <FileUpload
                  name="thumbnail-upload"
                  :key="`plans__upload--${plan.id}`"
                  :placeholder="
                    typeof plan.file == 'string'
                      ? plan.file.split('/')[plan.file.split('/').length - 1]
                      : 'Plan Pharmacie'
                  "
                  :acceptedTypes="[
                    'application/pdf',
                    'image/png',
                    'image/gif',
                    'image/bmp',
                    'image/jpeg',
                    'image/jpg',
                    'image/svg+xml',
                    'image/x-icon',
                    'image/pipeg',
                    'video/mp4',
                    'video/mpeg',
                    'video/quicktime',
                    'video/x-la-asf',
                    'video/x-ms-asf',
                    'video/x-msvideo',
                    'video/x-sgi-movie'
                  ]"
                  :upload="!plan.file"
                  @file-upload="fileUpload($event, `plans__${plan.id}`)"
                />
                <button
                  class="supports__form--button"
                  @click.prevent="removePlanLine(key, $event)"
                >
                  -
                </button>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="city">
            <span>Ville:</span>
            <el-input v-model="params.city" placeholder="Ville"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="postcode">
            <span>Code postal:</span>
            <el-input
              v-model="params.postcode"
              placeholder="Code Postal"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item prop="credits">
            <span>Credits :</span>
            <el-input v-model="params.credits" placeholder="Credits"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="slots">
            <span>Encarts gratuits :</span>
            <el-input
              v-model="params.slots"
              placeholder="Encarts gratuits"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item prop="total_slots">
            <span>Nombre d'encarts :</span>
            <el-input
              v-model="params.total_slots"
              placeholder="Nombre d'encarts"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <span>Type de compte:</span>
            <el-select
              no-data-text="..."
              popper-class="pharmacie-type"
              placeholder="Type de compte"
              filterable
              default-first-option
              v-model="params.type"
            >
              <el-option
                v-for="type in pharmaciesTypes"
                :key="`type__f-${type.id}`"
                :label="type.label"
                :value="type.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="isPharmacist">
        <el-col :span="12">
          <el-form-item class="supports__form--checkbox" prop="show_model">
            <CheckBox
              v-model="params.show_model"
              placeholder="Société"
              label="Afficher la visite 3D"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="params.show_model">
          <el-form-item prop="model">
            <span>ID du modèle Matterport:</span>
            <div class="supports__form--matterport">
              <el-input v-model="params.model" placeholder="ID Matterport" />
              <button
                class="supports__form--button supports__plan--view"
                @click.prevent="openMatterport()"
                v-if="params.model !== ''"
              >
                <img
                  width="25"
                  :src="require(`@/assets/eye.png`)"
                  alt="assets"
                />
              </button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Modifier</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  /* Button, */ Input,
  Select,
  Option,
  Form,
  FormItem,
  Message,
  InputNumber,
  Row,
  Col,
  DatePicker
} from "element-ui"
import { mapState, mapGetters } from "vuex"
import FileUpload from "@/components/FileUpload.vue"
import CheckBox from "@/components/Checkbox_Improved.vue"
import { updateUser, downloadUserRib } from "@/api/users"
import { getUserSupport } from "@/api/supports"
import { createSupport, updateSupport, deleteSupport } from "@/api/supports"
import { fetchAnnonceurs } from "@/api/users"
// import { getLabos } from "@/api/labos"
import { fetchCategories } from "@/api/categories"

import { loaderMixin } from "@/mixins"
import { emitter } from "@/utils"
import { isvalidEmail } from "@/utils/validate"
/**
 * checks if given image url is valid
 * @param {String} imgUrl - image url to check
 * @returns {Promise} - returns a promise that resolves
 * if image is valid and rejects if not
 */
/* const isValidImage = imgUrl => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve()
    img.onerror = () => reject()
    img.src = imgUrl
  })
} */
// import Multiselect from "vue-multiselect"

export default {
  components: {
    ElInput: Input,
    // ElButton: Button,
    ElSelect: Select,
    ElOption: Option,
    ElFormItem: FormItem,
    ElForm: Form,
    ElInputNumber: InputNumber,
    ElRow: Row,
    ElCol: Col,
    FileUpload,
    ElDatePicker: DatePicker,
    CheckBox
  },
  mixins: [loaderMixin],
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!isvalidEmail(value)) {
        callback(new Error("l'email est incorrect"))
      } else {
        callback()
      }
    }
    const validateSlots = (rule, value, callback) => {
      const intValue = Number.parseInt(value)
      if (!intValue && intValue !== 0) {
        callback(new Error("Ce champ est obligatoire"))
      } else if (intValue > this.params.total_slots) {
        callback(
          new Error(
            "Le nombre d'encarts gratuits doit être inférieur ou égale au nombre d'encarts "
          )
        )
      } else {
        callback()
      }
    }

    return {
      isPharmacist: false,
      test: true,
      params: {
        email: "",
        first_name: "",
        last_name: "",
        company: "",
        group: "",
        city: "",
        plannings_start_day: null,
        activity_started_at: null,
        role: null,
        postcode: "",
        rib: null,
        pharmacy_plans: [],
        supports: [],
        formats: {},
        categorie_id: null,
        chiffre_affaires: null,
        userSupports: [],
        labosIds: [],
        credits: 0,
        slots: 4,
        model: "",
        show_model: 1,
        type: "standard",
        total_slots: 10
      },
      existingPlans: [],
      removedPlans: [],
      newSupports: [],
      oldSupport: [],
      removedSupport: [],
      rules: {
        email: [{ required: true, trigger: "blur", validator: validateEmail }],
        role: [{ required: true }],
        first_name: [{ required: true }],
        last_name: [{ required: true }],
        slots: [{ validator: validateSlots, trigger: "blur" }],
        total_slots: [
          { required: true, message: "Le nombre d'encarts est obligatoire" }
        ]
      },
      roles: [
        { label: "Admin", value: "admin" },
        { label: "Freelance", value: "freelancer" },
        { label: "Pharmacien", value: "pharmacist" },
        { label: "Annonceur", value: "annonceur" }
      ],
      groups: [],
      categories: [],
      labos: [],
      pharmaciesTypes: [
        {
          id: "standard",
          label: "Compte standard"
        },
        {
          id: "Grand compte",
          label: "Grand compte"
        }
      ]
    }
  },
  computed: {
    ...mapGetters(["modal", "userInfo"]),
    ...mapState(["supports", "supportstypes"])
  },
  mounted() {
    this.params.userSupports = [...this.modal.payload.user.supports]
    this.oldSupport = [...this.modal.payload.user.supports]
    // this.params.show_model = !!+this.modal.payload.user.show_model
    //this.labos = [...this.modal.payload.user.labos]
    // this.params.plans
    if (!this.params.pharmacy_plans || !this.params.pharmacy_plans.length) {
      this.params.pharmacy_plans = []
    } else {
      this.params.pharmacy_plans = this.params.pharmacy_plans.map(
        (file, index) => {
          return {
            id: index + 1,
            file
          }
        }
      )
    }
    if (this.modal.payload.user.labos)
      this.params.labosIds = this.modal.payload.user.labos.map(labo => labo.id)
  },
  methods: {
    openMatterport() {
      const user = this.modal.payload.user
      const users = this.modal.payload.users
      this.$store.dispatch("closeModal")
      setTimeout(() => {
        // let type = url.split(".")
        // type = type[type.length - 1]
        this.$store.dispatch("openModal", {
          name: "matterport",
          payload: {
            return: true,
            model: this.params.model,
            user,
            infos: {
              name: "edit-user-form--admin",
              user,
              users
            }
          }
        })
      }, 200)
    },
    addPlanLine() {
      this.params.pharmacy_plans.push({
        id: this.params.pharmacy_plans.length + 1,
        file: null
      })
    },
    removeExistingPlanLine(index) {
      let plansBackup = [...this.existingPlans]
      setTimeout(() => {
        this.existingPlans = null
        plansBackup = plansBackup.filter((row, i) => {
          if (i === index) {
            this.removedPlans.push(row.id)
          }
          return i !== index
        })
        this.existingPlans = plansBackup
      }, 20)
    },
    removePlanLine(index) {
      let plansBackup = [...this.params.pharmacy_plans]
      setTimeout(() => {
        this.params.pharmacy_plans = null
        plansBackup = plansBackup.filter((row, i) => {
          return i !== index
        })
        this.params.pharmacy_plans = plansBackup
      }, 20)
    },
    addNewLine() {
      const tag = {
        name: "",
        type_support_id: 1,
        position: null,
        format: "",
        pharmacist_id: this.modal.payload.user.id,
        type_support: {
          is_global: 0
        }
      }
      this.params.userSupports.push(tag)
      this.newSupports.push(tag)
    },
    removeLine(index) {
      setTimeout(() => {
        let removed = this.params.userSupports.find((line, i) => i === index)
        if (removed) {
          let isFound = this.oldSupport.find(
            support => support.id === removed.id
          )
          if (isFound) {
            this.removedSupport.push(removed)
            this.oldSupport = this.oldSupport.filter(
              supp => supp.id !== removed.id
            )
          }
          this.params.userSupports = this.params.userSupports.filter(
            (supp, i) => i !== index
          )
        }
      }, 20)
    },
    fileUpload(file, index) {
      this.params.pharmacy_plans = this.params.pharmacy_plans.map((row, i) => {
        if (index === `plans__${i + 1}`) {
          row.file = file
        }
        return row
      })
    },
    openBlueprintModal(url) {
      const user = this.modal.payload.user
      const users = this.modal.payload.users
      this.$store.dispatch("closeModal")
      setTimeout(() => {
        // let type = url.split(".")
        // type = type[type.length - 1]
        this.$store.dispatch("openModal", {
          name: "pharmacy-blueprint-admin",
          payload: {
            imgUrl: url,
            user: user,
            plan: this.existingPlans,
            infos: {
              name: "edit-user-form--admin",
              user,
              users
            }
          }
        })
      }, 200)
    },
    handleSubmit() {
      this.$refs.editUserForm.validate(valid => {
        if (!valid) {
          return
        }

        this.openLoader(this.$refs.editModal)
        const { pharmacy_plans, ...params } = this.params
        // const show_model = this.params.show_model
        // Set files into a formData object to be
        // sent as data
        const formData = new FormData()
        if (this.params.rib) formData.append("rib", this.params.rib)
        // delete this.params.show_model
        if (pharmacy_plans) {
          pharmacy_plans.forEach((plan, index) => {
            if (plan.file && plan.file !== "") {
              formData.append(`pharmacy_plans[${index + 1}]`, plan.file)
            }
          })
        }

        this.removedPlans.forEach((plan_id, index) => {
          formData.append(`plans_to_delete[${index + 1}]`, plan_id)
        })
        // structure support formats
        for (const key in this.formats) {
          // check if key is still in supports
          if (params.supports.includes(+key)) {
            params.formats[key] = this.formats[key]
          }
        }

        this.newSupports.forEach(support => {
          if (support.name && support.format) {
            createSupport(support)
          }
        })
        this.oldSupport.forEach(support => {
          updateSupport(support.id, support)
        })
        this.removedSupport.forEach(support => {
          deleteSupport(support.id)
        })

        formData.append(`email`, this.params.email)
        formData.append(`first_name`, this.params.first_name)
        formData.append(`last_name`, this.params.last_name)
        formData.append(`company`, this.params.company)
        formData.append(`group`, this.params.group || "")
        formData.append(`city`, this.params.city)
        formData.append(`plannings_start_day`, this.params.plannings_start_day)
        if (this.params.activity_started_at) {
          // Nullable validation fails for the date when value is null
          formData.append(
            `activity_started_at`,
            this.params.activity_started_at
          )
        }
        formData.append(`role`, this.params.role)
        formData.append(`postcode`, this.params.postcode)
        formData.append(`category_id`, this.params.category_id)
        formData.append(`chiffre_affaires`, this.params.chiffre_affaires || 0)
        formData.append(`credits`, this.params.credits)
        formData.append(`slots`, this.params.slots)
        formData.append(`model`, this.params.model)
        formData.append(`type`, this.params.type)
        formData.append(`total_slots`, this.params.total_slots)
        formData.append(`show_model`, +this.params.show_model || 0)

        this.params.supports.forEach((support, index) => {
          formData.append(`supports[${index + 1}]`, support)
        })
        this.params.userSupports.forEach((userSup, index) => {
          formData.append(`userSupports[${index + 1}]`, userSup)
        })
        this.params.labosIds.forEach((labosIds, index) => {
          formData.append(`labosIds[${index + 1}]`, labosIds)
        })

        updateUser(this.modal.payload.user.id, {}, formData)
          .then(() => {
            Message.success("Utilisateur Modifié")
            emitter.$emit("update-table")

            this.closeLoader()
            this.$store.dispatch("closeModal")
          })
          .catch(() => {
            this.closeLoader()
            /*
            if (response && response.error && response.error.message) {
              Message.error(response.error.message);
              return;
            }
            
            setTimeout(() => {
              Message.error("Utilisateur n'est pas Modifié");
            }, 5000);
            */
          })
      })
    },
    downloadUserRib() {
      downloadUserRib(this.modal.payload.user.id)
        .then(value => {
          var newBlob = new Blob([value])
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement("a")
          link.href = data
          link.download = this.params.rib
          link.click()
          setTimeout(function() {
            window.URL.revokeObjectURL(data)
          }, 100)
          Message.success("RIB téléchargé")
        })
        .catch(() => {
          Message.success("RIB n'a pas été téléchargé.")
        })
    },
    handleDateChange(val) {
      this.params.activity_started_at = this.formatDate(val)
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = "0" + month
      if (day.length < 2) day = "0" + day

      return [year, month, day].join("-")
    },
    getAnnonceurs() {
      fetchAnnonceurs()
        .then(res => {
          //console.log(res.data);
          this.groups = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getCategories() {
      fetchCategories()
        .then(res => {
          //console.log(res)
          this.categories = res
        })
        .catch(err => {
          console.error(err)
        })
    },
    fetchLabos() {
      // TODO: Labos to V2
      /*
      getLabos()
        .then(res => {
          //console.log(res)
          this.labos = res
        })
        .catch(err => {
          console.error(err)
        })
      */
    }
  },
  created() {
    this.existingPlans = this.modal.payload.user.plans.map(
      ({ id, name, originalName }) => ({
        id,
        file: name,
        name: originalName
      })
    )
    this.$store.dispatch("getSupportsTypes")
    const setParams = () => {
      const { user } = this.modal.payload
      for (const key in user) {
        if (this.params.hasOwnProperty(key)) {
          if (key === "show_model") {
            this.params[key] = !!+user[key]
          } else {
            this.params[key] = user[key]
          }
        }
      }
      // Check the user's role
      if (user.role === "pharmacist") {
        this.isPharmacist = true
        getUserSupport(user.id).then(res => {
          const supports = res.data.map(supp => supp.id)
          const formats = {}

          for (const supp of res.data) {
            if (supp.pivot && supp.pivot.formats) {
              // only keep unique items since duplicate
              // keys causes errors in element-ui's multi select
              formats[supp.id] = [...new Set(JSON.parse(supp.pivot.formats))]
            }
          }
          this.params.supports = supports
          this.formats = formats
        })
      }
    }
    if (!this.supports.data.options.length) {
      this.$store.dispatch("getSupports").then(() => {
        setParams()
        this.fetchedSupports = this.supports.data.options
      })
    } else {
      setParams()
    }

    // Get the groupements
    this.getAnnonceurs()

    // Get the categories
    this.getCategories()

    //Get Labos
    this.fetchLabos()
  }
}
</script>
<style lang="scss">
.supports__form {
  &--checkbox {
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
    label {
      margin-left: 0 !important;
      margin-top: 10px;
      .checkbox__mark {
        margin-right: 1rem;
      }
    }
  }
  &--matterport {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .supports__plan--view {
      margin-right: 0 !important;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
.no-margin {
  margin-top: 0 !important;
}
.supports__plan--view {
  margin-right: 10px;
}
.supports__form {
  &--container {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
  &--plan {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // max-height: 50px !important;
    .supports__form--button {
      min-width: 48px !important;
      margin-left: 10px;
    }
    .file-upload {
      min-width: unset !important;
      width: 100%;
      max-width: 360px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      &__alert {
        word-break: break-word;
      }
      &__inner-wrapper {
        height: 50px;
      }
      .file-upload__file-name {
        max-width: 360px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div.link {
        line-height: unset !important;
        a {
          height: 30px;
        }
      }
      .file-upload__inner-wrapper {
        width: 100%;
      }
    }
  }
  &--actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-item {
    display: grid;
    grid-template-columns: 1fr 1fr 0.5fr 0.2fr;
    grid-gap: 10px;
    // justify-items: center;
    justify-items: flex-end;
  }
  &--button {
    // background-color: #000;
    cursor: pointer;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fbac2e;
    border: 2px solid var(--color-secondary, #fbac2e);
    outline: none;
    color: white;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    font-size: 25px;
    text-transform: uppercase;
    background: var(--color-secondary, #fbac2e);
    &:hover {
      box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.16);
    }
    &.marged {
      margin: 0 14px 20px auto;
    }
  }
}
.supports-select {
  margin: 5px 0;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.multiselect__select {
  z-index: 22;
}

.multiselect__select:before {
  color: $color-secondary;
  color: var(--color-secondary, $color-secondary);
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0;
  border-color: $color-secondary transparent transparent;
  border-color: var(--color-secondary, $color-secondary) transparent transparent;
}

.multiselect__tag {
  margin-bottom: 0;
  &s {
    border-radius: 0;
    max-height: 110px;
    padding: 4px 40px 0 8px;
  }
}

.multiselect__tag,
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: $color-secondary;
  background-color: var(--color-secondary, $color-secondary);
}

.multiselect__tag-icon,
.multiselect__tag-icon::after {
  color: #fff;
}

.multiselect__tag-icon::after {
  content: "✕";
  font-size: 12px;
}

.multiselect__content-wrapper {
  border-radius: 0;
}

.multiselect__option {
  background-color: #fff;
}

.multiselect__tags-wrap {
  margin-top: 9px;
  display: block;
}
.multiselect__option--highlight {
  &::after {
    background: transparent !important;
    color: $color-primary--dark !important;
  }
}

.multiselect__option,
.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight::after {
  color: $color-primary--dark;
  color: var(--color-primary--dark, $color-primary--dark);
  font-weight: 400;
  font-size: 0.785em;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #fef9f1;
}

/**
  * Custom Scroller
  */
.os-theme-orange > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle,
.os-theme-orange.os-host-transition
  > .os-scrollbar
  > .os-scrollbar-track
  > .os-scrollbar-handle {
  background: rgba(251, 172, 46, 0.555);
}

.os-theme-orange > .os-scrollbar > .os-scrollbar-track,
.os-theme-orange.os-host-transition > .os-scrollbar > .os-scrollbar-track {
  background: rgba(238, 238, 238, 0.445);
}

.os-theme-orange
  > .os-scrollbar-horizontal
  > .os-scrollbar-track
  > .os-scrollbar-handle {
  max-width: 16px;
}

.os-theme-orange
  > .os-scrollbar-vertical
  > .os-scrollbar-track
  > .os-scrollbar-handle {
  max-height: 16px;
}
</style>
